import {
    createAsyncThunk
} from '@reduxjs/toolkit';
import axios from 'axios';
import {
    api
} from '../../helpers/api_helper';
import {
    API_ENDPOINTS
} from '../../constants/apiEndPoints';


export const getNotification = createAsyncThunk('notification', async ({
    limit,
    page
}, thunkAPI) => {
    try {
        const response = await api.get(API_ENDPOINTS.NOTIFICATION.GET, {
            limit,
            page
        });
        return response.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response.data);
    }
});
